import { render, staticRenderFns } from "./SwatchQuilt.vue?vue&type=template&id=7d27bb38&scoped=true&"
import script from "./SwatchQuilt.vue?vue&type=script&lang=js&"
export * from "./SwatchQuilt.vue?vue&type=script&lang=js&"
import style0 from "./SwatchQuilt.vue?vue&type=style&index=0&id=7d27bb38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d27bb38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VCol,VImg})
